<template>
    <div id="AppConditions" class="app-inner">
         <div class="public-btn-div flex align-cen"  >
    </div>
         <div class="p-tit-c">
            <div class="businessList-filter">
                     <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">提交客户团队名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入提交客户团队名称" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">提交客户手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入提交客户手机号" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                      <div class="fl-rt flex align-cen">
                    <div class="label">问题ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入问题ID" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">问题类型：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="classSelect" >仿真软件问题</el-radio>
        <el-radio v-model="radio" label="2" @change="classSelect">课程问题</el-radio>
         <el-radio v-model="radio" label="3" @change="classSelect">其他问题</el-radio>
      </div>
          <div class="businessList-filter-list flex align-cen">
                     <div class="label">反馈时间：</div>
                      <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect"
                            >
                            </el-date-picker>
                  </div>
        <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
            </div>
         </div>
            <div class="businessList-container">
        <div class="businessList-container-table">
          <el-table
                ref="multipleTable"
                :data="list"
                border
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column prop="id" label="问题ID" align="center">
                 </el-table-column>
                  <el-table-column prop="type" label="问题类型" align="center">
                    <template slot-scope="scope">
                       <span>{{scope.row.type == 1 ? '仿真软件问题' : scope.row.type == 2 ? '课程问题' : '其他问题'}}</span>
                      </template>
                 </el-table-column>
                      <el-table-column prop="loginName" label="客户手机号" align="center">
                 </el-table-column>
                    <el-table-column prop="businessName" label="提交企业名称" align="center">
                 </el-table-column>
                       <el-table-column prop="content" label="反馈内容" align="center">
                    <template slot-scope="scope">
                       <span>{{scope.row.content}}</span>
                      </template>
                 </el-table-column>
                    <el-table-column prop="createTime" label="反馈时间" align="center">
                 </el-table-column>
                     <el-table-column prop="followNum" label="跟进次数" align="center">
                 </el-table-column>
              <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openWater(scope.row)">查看跟进</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          </el-table>
           <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
            </div>
             <el-dialog
      title="问题反馈跟进记录"
    :visible.sync="centerDialogVisible1"
    width="50%"
    :append-to-body="true"
    center
      >
        <div class="followList-dialog">
                         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  跟进
            </div>
             <div class="public-tit-list mft" style="cursor: pointer;"
             @click.stop="openAddfollowList"
             >
                <i class="icon-al-plus-circle-fill"></i>
                 添加跟进
             </div>
        </div>
                         <div class="followList">
                <div class="followList-item"
                v-for="(item, index) in followList" :key="index"
                >
                    <div class="remark">{{item.content}}</div>
                    <div class="info flex align-cen">
                        <div class="info-time">{{item.createTime}}</div>
                       <div class="info-username">{{item.createBy}}</div>
                    </div>
                </div>
             </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import {getAppFeedback,feedbackFollowList,addFo3} from "@/api/index/index" //反馈列表、跟进列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
   components:{
      paginaTion,
    },
    data() {
        return {
           centerDialogVisible1:false,
           followList:[],
           feedbackId:'',
           search:'',
           search1:'',
           search2:'',
           options:[],
           classCurrentPage: 1, //初始页
            classPageSize: 10000, //每页的数据
           currentPage:1,
           pageSize:10,
            value:'',
            value1:[],
            radio:'',
            list:[],
            totalCount:0,
              startTime:'',
        endTime:'',
                   pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    activated(){
  this.getList()
},
    created() {
    },
    methods: {
        // 打开反馈详情
           detail(data){
            this.$router.push({
            name: "issueDetail",
            query:{
                id:data.id,
            }
           })
        },
           // 打开添加跟进窗口
        openAddfollowList(){
                   this.$prompt('跟进内容', '添加问题反馈跟进', {
                customClass:'follow-box',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType:'textarea',
                inputPlaceholder:'必填【1-500】',
                inputPattern: /^\S{1,500}$/,
                inputErrorMessage: '输入不符合规则'
                }).then(({ value }) => {
                this.addFollow(this.feedbackId,value)
                }).catch(() => {       
                });
        },
          addFollow(id,content){
             // 打开跟进窗口
                addFo3({
                feedbackId:id,
                content:content
              })
            .then(res => {
                if(res.code == 0){
                   this.$message.success('添加成功')
                  this.getFollowList(id)
                   this.getList()
                }else{
                    this.$message.error(res.msg)
                }
            })
            .catch(err => {
            })
          },
          getFollowList(id){
          feedbackFollowList({
                id:id
              })
            .then(res => {
                this.feedbackId = id
                this.followList = res.data
            })
            .catch(err => {
            })
        },
         // 打开跟进窗口
        openWater(data){
            this.getFollowList(data.id)
            this.centerDialogVisible1 = true
        },
        getList(){
            let params = {
                businessName:this.search,
                loginName:this.search1,
                id:this.search2,
                type:this.radio,
                startTime:this.startTime || '',
                endTime:this.endTime || '',
                current:this.currentPage,
                size:this.pageSize
            }
            getAppFeedback(params)
            .then(res =>{
              if(res.data.records){
                this.list = res.data.records
                this.totalCount = res.data.total
              }
            })
        },
        // 筛选
        classSelect(){
             if(this.value1){
             this.startTime = this.value1[0]
            this.endTime =  this.value1[1]
            }else{
                 this.startTime = ''
            this.endTime =  ''
            }
           this.currentPage = 1
           this.getList()
        },
        // 启用状态
        allradio(){
          this.radio = ''
          this.currentPage = 1
        this.getList()
        },
        //重置
        reset(){
           this.search1=""
          this.search=""
           this.search2=""
          this.value = ''
          this.radio = ''
          this.currentPage=1
          this.getList()
        },
        // 查看详情
        omDetail(data){
          this.$router.push({
            name: "omDetail",
            query:{
                id:data.id
            }
           })
        },
                         // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    },
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  ::v-deep{
     .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
  }
</style>